import { render, staticRenderFns } from "./DocumentsPopup.vue?vue&type=template&id=3987d42c&scoped=true"
import script from "./DocumentsPopup.vue?vue&type=script&lang=js"
export * from "./DocumentsPopup.vue?vue&type=script&lang=js"
import style0 from "./DocumentsPopup.vue?vue&type=style&index=0&id=3987d42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987d42c",
  null
  
)

export default component.exports